import Button from "./Button";

export default function LogoutButton() {
  return (
    <Button
      label="Log uit"
      color="blue"
      icon="exit"
      onClick={() => {
        const confirmed = window.confirm("Uitloggen?");
        if (confirmed) {
          window.sessionStorage.clear();
          window.location.href = "/o/logout/";
        }
      }}
    />
  );
}
